import { render } from "./CreateWordGroupModal.vue?vue&type=template&id=29fd1420"
import script from "./CreateWordGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateWordGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__